import { UnorderedListOutlined } from '@ant-design/icons';

import StoreCategoryPage from '../pages/StoreCategoryPage';

import { SiteMap } from './index';

export const storeCategoryRoutes: SiteMap = {
  'store-category': {
    title: '업종 관리',
    page: StoreCategoryPage,
    key: '/store-category',
    icon: <UnorderedListOutlined />,
    role: ['admin'],
  },
};
